// removed by extract-text-webpack-plugin
module.exports = {"carousel-container":"src-components----ReviewCarousel-module---carousel-container---1B7YR"};


//////////////////
// WEBPACK FOOTER
// ./src/components/ReviewCarousel.module.css
// module id = 993
// module chunks = 35783957827783